import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const viewStandardFlowRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-virtualagent-view-standard-flow',
	exact: true,
	path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/standard-flows/:flowId/:tab(flow|settings)?',
};
